import request from '@/utils/request'

const login = (data) => {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

export default {
  login
}
